import React, {Component} from 'react';
import {connect,Provider} from 'react-redux'
import {Box} from 'reactjs-admin-lte'
import {Button,InputGroup,Row,Col,Tabs,Tab} from 'react-bootstrap'
import FontAwsome from 'react-fontawesome'
import { Checkbox } from 'react-icheck';
// import SWTCarEditPopup from './SWTCarEditPopup'
// import SWTNewCustomerPopup from '../workdoc/SWTNewCustomerPopup';
import '../../workdoc/WorkDoc.css';
import FormJsonSchema from "react-jsonschema-form";
// import LayoutField from "react-jsonschema-form-layout";
import {createStore} from 'redux'
import * as _ from 'lodash';
import {FormReducer} from 'component/element/workdoc/FormReducer'
import CustomFieldTemplate from 'component/element/workdoc/CustomFieldTemplate';
import EditInputTypePopup from 'component/element/workdoc/popup/EditInputTypePopup';
import WorkdocStore from 'stores/WorkdocStore'
import TyreStore from 'stores/TyreStore'
import SelectWithIcon from 'component/element/workdoc/SelectWithIcon' 
import CheckWidget from 'component/element/workdoc/CheckWidget' 

import {DEFAULT_SCHEMA,DEFAULT_UI_SCHEMA} from './AssetWorkDocGenFormSchema'
const NotificationSystem = require('react-notification-system')
const store = createStore(FormReducer);

class AssetWorkDocGenForm extends Component {
  initialData = {
    vehicle: {
      vehicle_registration_no: '',
      vehicle_type: '',
      model_id: '0',
      model: '',
      year: '',
      chassis_no: '',
      mileage: '',
      vehicle_color: '',
      accident_type: '',
      vehicle_at: '',
      province: '',
      brand_id: '0',
      brand: '',
      series_id: '0',
      series: '',
      engine_no: '',
      damage: '',
      paint_type: '',
      vehicle_no: '',
    },
    driver: {
      title: '',
      name: '',
      pay_type: '',
      payment_method: '',
      tel: '',
      other_tel: '',
      payment_method_remark: '',
      installation:'',
      installation_component:this.props.workNo
    },
    contact: {
      title: '',
      name: '',
      tel: '',
      other_tel: ''
    },
    receiving: {
      contact_date: '',
      contact_time: '',
      entrance_date: '',
      entrance_time: '',
      entrance_name_as: '',
      entrance_name: '',
      tel: '',
      other_tel: '',
      park_status: '',
      order_part: '',
      advance_date: '',
      appointment_date: '',
      fixing_day: '',
      receiving_by: '',
      openwork_by: '',
      checking_by: '',
      remark: '',
      emcs_no: '',
    },
    delivering: {
      delivering_date: '',
      relationship: '',
      result: '',
      asset: '',
      delivered_by: '',
      delivering_name_as: 'other',
      delivering_name: '',
      address: '',
      identity_no: '',
      tel: '',
      other_tel: '',
      tel_forsms: '',
    },
    insurer: {
      insurer_name: '',
      policy_no: '',
      claim_no: '',
      accident_no: '',
      claim_by: '',
      branch: '',
      policy_type: '',
      protection_money: '',
      accident_receiving_date: '',
      accident_date: ''
    }
  };

  constructor(...args){
    super(...args)

    const Fields = {};
    const Widgets = {};

    this.state = {
      status:'0',
      deleted:'0',
      activeKey:0,
      showCarPopup:false,
      showCustomerPopup:false,
      schema:DEFAULT_SCHEMA,
      uiSchema:DEFAULT_UI_SCHEMA,
      editInput: {},
      formData: JSON.parse(JSON.stringify(this.initialData)),
      formContext: {
        onEdit: this.onEdit,
        onMoveBefore: this.onMoveBefore,
        onMoveAfter: this.onMoveAfter,
        onMoveRow: this.onMoveRow,
        onRemove: this.onRemove,
        onSplitRow: this.onSplitRow,
        editMode: false,
        formData: JSON.parse(JSON.stringify(this.initialData)),
      },
      fields: Fields,
      widgets: Widgets,
    }

    this.state = {
      ...this.state,
      formContext: {
        ...this.state.formContext,
        schema: DEFAULT_SCHEMA,
        uiSchema: DEFAULT_UI_SCHEMA,
        fields: Fields,
        widgets: Widgets,
      }
    };
    this.initial();  
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData(this.props.workNo)
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show&&newProps.show!==this.props.show) {
      this.setState({activeKey:0})
      if (newProps.workNo!==''&&newProps.action==='edit')
        this.loadData(newProps.workNo)
      else
        this.loadNewDoc()
    }

    if (newProps.status!==this.state.status) {
      this.setState({status:newProps.status})
    }
    
    if (newProps.deleted!==this.state.deleted) {
      this.setState({deleted:newProps.deleted})
    }
  }

  initial() {
    let {schema,formContext} = this.state
    _.each(schema, (item, index) => {
      if (!item.group) {
        item.group = index;
      }
      _.each(item.properties, (field) => {
        if (!field.group) {
          field.group = index;
        }
      });
    });

    formContext.schema = schema
    this.setState({formContext:formContext,schema:schema})
  }

  loadNewDoc() {
    let {formData,formContext} = this.state
    formData = JSON.parse(JSON.stringify(this.initialData))
    formContext.formData = JSON.parse(JSON.stringify(this.initialData))
    this.setState({formData:formData,formContext:formContext})
  }

  loadData(workNo) {
    let {formData,formContext,schema,uiSchema} = this.state
    this.setState({loading:true})
    WorkdocStore.loadAssetWorkInfo(workNo,(result)=>{
      formData = Object.assign(formData,result.data)
      formData.driver = Object.assign({installation_component:workNo},formData.driver)
      formContext.formData = formData

      this.conditionVehicleType(formData.vehicle,uiSchema.vehicle)      

      this.setState({loading:false,formData:formData,formContext:formContext,schema:schema,status:result.data.status,deleted:result.data.deleted})
      if (this.props.onReturnStatus!==undefined)
        this.props.onReturnStatus(result.data.status)
      if (this.props.onReturnDeleted!==undefined)
        this.props.onReturnDeleted(result.data.deleted)  
    })
  }

  loadAssetVehicle(vehicle_id) {
    let {formData,formContext} = this.state
    this.setState({loading:true})
    TyreStore.loadAssetVehicle(vehicle_id,(result)=>{
      formData = Object.assign(formData,result.data)
      formContext.formData = formData
      
      this.setState({loading:false,formData:formData,formContext:formContext})
    })
  }

  onSaveClick(){
    this.setState({loading:true})
    let {formData} = this.state
    let postData = {work_no:this.props.workNo,contact:formData.contact,delivering:formData.delivering,driver:formData.driver,insurer:formData.insurer,receiving:formData.receiving,vehicle:formData.vehicle}
    WorkdocStore.saveAssetWorkInfo(postData,(result)=>{
      if (result.status==='OK') {
        this.setState({loading:false})
        this.loadData(this.props.workNo)
        this.props.onUpdateAction('edit')
        this._notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'บันทึกรายการสำเร็จ',
          level: 'info',
          position: 'tc'
        });
      }
    },()=>{
      this.setState({loading:false})
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'บันทึกรายการไม่สำเร็จ',
        level: 'error',
        position: 'tc'
      });
    })
  }

  onCustomerPopupClick(e) {
    // let {showCustomerPopup} = this.state
    this.setState({showCustomerPopup:true})
  }

  renderButtonCustomer() {
    return(
      <InputGroup.Addon 
        className="btn"
        onClick={this.onCustomerPopupClick.bind(this)}
      >
        <FontAwsome name='plus' />
      </InputGroup.Addon>
    )
  }

  onEdit = (type, field) => {
    return (e) => {
      let ui_type = 'ui:widget';
      let ui_value = '';
      if (this.state.uiSchema[type][field] &&
          this.state.uiSchema[type][field]['ui:field']) {
        ui_type = 'ui:field';
      }
      if (this.state.uiSchema[type][field] &&
          this.state.uiSchema[type][field][ui_type]) {
        ui_value = this.state.uiSchema[type][field][ui_type];
      }
      let columnSize = 6;
      let columnOffset = 0;
      _.each(this.state.uiSchema[type]['ui:layout'], item => {
        let layout_item = _.find(item, {name: field});
        if (layout_item && layout_item.props) {
          columnSize = +(layout_item.props.md || 6);
          columnOffset = +(layout_item.props.mdOffset || 0);
        }
      });

      const schemaField = this.state.schema[type].properties[field] || {};

      let title = schemaField.title || '';
      let enums = schemaField.enum || [];
      let enumNames = schemaField.enumNames || [];
      if (ui_value === '') {
        if (!_.isEmpty(enums)) {
          ui_value = 'select';
        } else {
          ui_value = 'text';
        }
      }
      let input_type = `${ui_type}|${ui_value}`;

      /**
       * Check Placeholder
       */
      let placeholder = {
        placeholder: '',
      };
      if (this.state.uiSchema[type][field] &&
          this.state.uiSchema[type][field]['ui:placeholder']) {
        placeholder.placeholder = this.state.uiSchema[type][field]['ui:placeholder'];
      }

      /**
       * Check Autocomplete
       */
      let autocomplete = {};
      if (schemaField.options) {

        autocomplete = {
          ...autocomplete,
          ..._.pick(schemaField.options, [
            'autocomplete_type',
            'autocomplete_label',
            'autocomplete_value',
          ]),
        };
      }

      this.setState({
        inputTypePopup: true,
        editInput: {
          group: type,
          type: input_type,
          name: field,
          size: columnSize,
          offset: columnOffset,
          label: title,
          enums: enums.join(','),
          enumNames: enumNames.join(',') || enums.join(','),
          required: _.indexOf(this.state.schema[type].required,
              field) !== -1,
          ...placeholder,
          ...autocomplete,
        },
      });

      // console.log(type, field, e);
    };
  };

  onMoveBefore = (type, name) => {
    return (e) => {
      // console.log('move before');
      const {
        uiSchema, formContext,
      } = this.state;
      let newUISchema = {
        ...uiSchema,
      };
      // let newSchema = {
      //   ...schema,
      // };

      for (let index in newUISchema[type]['ui:layout']) {
        const item = newUISchema[type]['ui:layout'][index];
        let field = _.find(item, {name});
        if (field) {
          const current_index = _.indexOf(item, field);
          const new_index = current_index - 1;
          item.splice(current_index, 1);
          if (current_index === 0 && index > 0) {
            --index;
            newUISchema[type]['ui:layout'][index].push(field);
          } else {
            newUISchema[type]['ui:layout'][index] = [
              ...item.slice(0, new_index),
              field,
              ...item.slice(new_index)];
          }
          break;
        }
      }

      newUISchema[type]['ui:layout'] = _.filter(newUISchema[type]['ui:layout'],
          item => !_.isEmpty(item));

      this.setState({
        uiSchema: newUISchema,
        formContext: {
          ...formContext,
          uiSchema: newUISchema,
        },
      }, () => this.refreshEditMode());
    };
  };

  onSplitRow = (type, name) => {
    return (e) => {
      // console.log('split row');
      const {
        uiSchema, formContext,
      } = this.state;
      let newUISchema = {
        ...uiSchema,
      };
      // let newSchema = {
      //   ...schema,
      // };

      for (let index in newUISchema[type]['ui:layout']) {
        const item = newUISchema[type]['ui:layout'][index];
        let field = _.find(item, {name});
        if (field) {
          const current_index = _.indexOf(item, field);
          item.splice(current_index, 1);

          newUISchema[type]['ui:layout'] = [
            ...newUISchema[type]['ui:layout'].slice(0, index),
            [field],
            ...newUISchema[type]['ui:layout'].slice(index),
          ];
          break;
        }
      }

      newUISchema[type]['ui:layout'] = _.filter(newUISchema[type]['ui:layout'],
          item => !_.isEmpty(item));

      this.setState({
        uiSchema: newUISchema,
        formContext: {
          ...formContext,
          uiSchema: newUISchema,
        },
      }, () => this.refreshEditMode());
    };
  };

  onMoveAfter = (type, name) => {
    return (e) => {
      // console.log('move after');
      const {
        uiSchema, formContext,
      } = this.state;
      let newUISchema = {
        ...uiSchema,
      };
      // let newSchema = {
      //   ...schema,
      // };

      for (let index in newUISchema[type]['ui:layout']) {
        const item = newUISchema[type]['ui:layout'][index];
        let field = _.find(item, {name});
        if (field) {
          const current_index = _.indexOf(item, field);
          const new_index = current_index + 1;
          item.splice(current_index, 1);
          if (new_index > item.length) {
            ++index;
            if (!newUISchema[type]['ui:layout'][index]) {
              newUISchema[type]['ui:layout'][index] = [];
            }
            newUISchema[type]['ui:layout'][index].unshift(field);
          } else {
            newUISchema[type]['ui:layout'][index] = [
              ...item.slice(0, new_index),
              field,
              ...item.slice(new_index)];
          }
          break;
        }
      }
      newUISchema[type]['ui:layout'] = _.filter(newUISchema[type]['ui:layout'],
          item => !_.isEmpty(item));

      this.setState({
        uiSchema: newUISchema,
        formContext: {
          ...formContext,
          uiSchema: newUISchema,
        },
      }, () => this.refreshEditMode());

    };
  };

  onMoveRow = (type, current_index, direction) => {
    return (e) => {
      // console.log('move row', direction);
      const {
        uiSchema, formContext,
      } = this.state;
      let newUISchema = {
        ...uiSchema,
      };
      
      const new_index = current_index + direction;
      const row = newUISchema[type]['ui:layout'].splice(current_index,
          1);
      newUISchema[type]['ui:layout'] = [
        ...newUISchema[type]['ui:layout'].slice(0, new_index),
        ...row,
        ...newUISchema[type]['ui:layout'].slice(new_index)];

      // console.log('newUISchema', newUISchema);

      this.setState({
        uiSchema: newUISchema,
        formContext: {
          ...formContext,
          uiSchema: newUISchema,
        },
      }, () => this.refreshEditMode());

    };
  };

  onRemove = (type, field) => {
    return (e) => {
      if (!window.confirm('Confirm?')) {
        return false;
      }
      // console.log('onremove', type, field);

      const {
        uiSchema, schema, formContext,
      } = this.state;
      let newUISchema = {
        ...uiSchema,
      };
      let newSchema = {
        ...schema,
      };

      try {
        delete newSchema[type].properties[field];

        _.each(newUISchema[type]['ui:layout'], item => {
          let layout_item = _.find(item, {name: field});
          if (layout_item) {
            const item_index = _.indexOf(item, layout_item);
            item.splice(item_index, 1);
          }
        });

      } catch (ex) {}

      this.setState({
        uiSchema: newUISchema,
        schema: newSchema,
        formContext: {
          ...formContext,
          uiSchema: newUISchema,
          schema: newSchema,
        },
      }, () => this.refreshEditMode());

    };
  };

  refreshEditMode = () => {
    const {formContext} = this.state;
    this.setState({
      formContext: {
        ...formContext,
        editMode: false,
      },
    }, () => {
      this.setState({
        formContext: {
          ...formContext,
          editMode: true,
        },
      });
    });
  };

  handleEditSchema = (e) => {
    const {
      uiSchema, schema, formContext,
      editInput,
    } = this.state;
    let newUISchema = {
      ...uiSchema,
    };
    let newSchema = {
      ...schema,
    };


    const ui_type = e.type.split('|');
    // console.log('edit schame', e);

    /**
     * Data Type
     */
    let field_type = 'string';
    let options = {};
    let enums = undefined;
    let enumNames = undefined;
    switch (e.type) {
      case 'ui:widget|select':
      case 'ui:widget|radio':
        field_type = 'string';
        enums = e.enums.split(',');
        enumNames = (e.enumNames || e.enums).split(',');
        break;

      case 'ui:widget|checkbox':
        field_type = 'boolean';
        break;

      case 'ui:field|InputAutoComplete':
        options.autocomplete_type = e.autocomplete_type;
        options.autocomplete_label = e.autocomplete_label;
        options.autocomplete_value = e.autocomplete_value;
        break;

      case 'ui:field|SelectCarBrand':
      case 'ui:field|SelectCarModel':
      case 'ui:field|SelectCarSeries':
      case 'ui:field|SelectColor':
      case 'ui:field|SelectProgramList':
      case 'ui:field|SelectCustomer':
        break;
      case 'ui:field|SelectWithIcon':
        break;

      default:
        field_type = 'string';
        break;
    }

    /**
     * Create / Update
     */
    if (editInput.name === '') {
      newSchema[e.group].properties[e.name] = {
        title: e.label,
        group: e.group,
      };
      newUISchema[e.group]['ui:layout'].push([
        {
          name: e.name,
          props: {
            md: e.size,
            mdOffset: e.offset,
          },
        }]);
    } else {

      if (e.name !== editInput.name) {
        newSchema[e.group].properties[e.name]
            = newSchema[e.group].properties[editInput.name];
        delete newSchema[e.group].properties[editInput.name];
      }

      _.each(newUISchema[e.group]['ui:layout'], item => {
        let field = _.find(item, {name: editInput.name});
        if (field) {
          field.name = e.name;
          field.props = {
            ...field.props,
            md: +e.size,
            mdOffset: +e.offset,
          };
        }
      });

    }

    /**
     * Set properties
     */
    newSchema[e.group].properties[e.name].title = e.label;
    newSchema[e.group].properties[e.name].type = field_type;
    newSchema[e.group].properties[e.name].options = options;
    newSchema[e.group].properties[e.name].enum = enums;
    newSchema[e.group].properties[e.name].enumNames = enumNames;

    /**
     * Set Widget
     */
    newUISchema[e.group][e.name] = {
      [ui_type[0]]: ui_type[1],
      'ui:placeholder': e.placeholder,
      'ui:inline': true,
    };

    /**
     * Set Required
     */
    schema[e.group].required = _.without(schema[e.group].required,
        editInput.name);
    if (e.required) {
      schema[e.group].required = [].concat(schema[e.group].required,
          [e.name]);
    }

    // console.log({
    //   uiSchema: newUISchema,
    //   schema: newSchema,
    // });

    this.setState({
      uiSchema: newUISchema,
      schema: newSchema,
      formContext: {
        ...formContext,
        uiSchema: newUISchema,
        schema: newSchema,
      },
    }, () => this.refreshEditMode());
  };

  conditionVehicleType(formData,uiSchema){
    if(formData.vehicle_type==='TRAILER'){
      uiSchema['has_tail'] = {classNames:'hidden'}
      uiSchema['has_head'] = {'ui:field':CheckWidget}
      if(formData.has_head){
        uiSchema['head_province'] = {'ui:field': SelectWithIcon}
        uiSchema['head_vehicle_registration_no'] = {}
      }else{
        uiSchema['head_province'] = {'classNames':'hidden'}
        uiSchema['head_vehicle_registration_no'] = {'classNames':'hidden'}
      }
      uiSchema['tail_province'] = {'classNames':'hidden'}
      uiSchema['tail_vehicle_registration_no'] = {'classNames':'hidden'}    
    }else{
      uiSchema['has_head'] = {classNames:'hidden'}
      uiSchema['has_tail'] = {'ui:field':CheckWidget}
      if(formData.has_tail){
        uiSchema['tail_province'] = {'ui:field': SelectWithIcon}
        uiSchema['tail_vehicle_registration_no'] = {}
      }else{
        uiSchema['tail_province'] = {'classNames':'hidden'}
        uiSchema['tail_vehicle_registration_no'] = {'classNames':'hidden'}
      }
      uiSchema['head_province'] = {'classNames':'hidden'}
      uiSchema['head_vehicle_registration_no'] = {'classNames':'hidden'}    
    }
    
  }

  onFormChange(type,e) {
      let {formData,uiSchema} = e;
      if (type==='vehicle'){
        if(typeof e.formData.vehicle_registration_no.vehicle_id!=='undefined') {
          let vehicle_id = e.formData.vehicle_registration_no.vehicle_id
          e.formData.vehicle_id = e.formData.vehicle_registration_no.vehicle_id
          e.formData.vehicle_registration_no = e.formData.vehicle_registration_no.label
          this.loadAssetVehicle(vehicle_id)
        }else if(e.formData.brand_id.value!==undefined){          
          formData.brand = formData.brand_id.label
          formData.brand_id = formData.brand_id.value
        }else if(e.formData.model_id.value!==undefined){          
          formData.model = formData.model_id.label
          formData.model_id = formData.model_id.value
        }else if(e.formData.series_id.value!==undefined){          
          formData.series = formData.series_id.label
          formData.series_id = formData.series_id.value
        }
        this.conditionVehicleType(formData,uiSchema)
      } else if (type==='insurer'){
        if(e.formData.insurer_id.value!==undefined){                     
          formData.insurer_name = formData.insurer_id.label
          formData.insurer_id = formData.insurer_id.value
        }        

      } else if (type==='driver'&&formData.name.isSelect) {
        formData.identity_no = formData.name.identity_no
        formData.other_tel = formData.name.other_tel
        formData.tel = formData.name.tel
        formData.title = formData.name.title
        formData.name = formData.name.name 
      } else if (type==='receiving') {
        let times = formData.contact_date.split(' ');
        if (times.length>1) {
          formData.contact_time = times[1]
        }  
      }

      let newFormData = {
        ...this.state.formData,
        [type]: {
          ...this.state.formData[type],
          ...formData,
        },
      };   

      let new_state = {
        formContext: {
          ...this.state.formContext,
          formData: newFormData,
        },
        formData: newFormData,
      };
      this.setState(new_state, () => {
        // console.log(type, 'form data updated');
      });
  };

  // onCustomerTypeChange(_props) {
  //   let {uiSchema} = this.state
  //   if (_props.state.formData.driver.pay_type==='credit')
  //     uiSchema.driver['ui:layout'][2][0].doShow = false
  //   else
  //     uiSchema.driver['ui:layout'][2][0].doShow = true
  // }

  // onCustomerPaymentMethodChange(_props) {
  //   let {uiSchema,schema} = this.state
  //   let payment_method = _props.state.formData.driver.payment_method
  //   if (payment_method==='transfer'||payment_method==='check'||payment_method==='creditcard') {
  //     uiSchema.driver['ui:layout'][4][0].doShow = false
  //     if (payment_method==='transfer')
  //       schema.driver.properties.payment_method_remark.title = 'ธนาคาร'
  //     else if (payment_method==='check')
  //       schema.driver.properties.payment_method_remark.title = 'เลขที่เช็ค'
  //     else if (payment_method==='creditcard')
  //       schema.driver.properties.payment_method_remark.title = 'หมายเลขบัตรเครดิต'    
  //   } else {
  //     uiSchema.driver['ui:layout'][4][0].doShow = true
  //     schema.driver.properties.payment_method_remark.title = ''
  //   }  
  // }

  // onCustomerInstallationChange(_props) {
  //   let {uiSchema} = this.state
  //   if (_props.state.formData.driver.installation==='yes')
  //     uiSchema.driver['ui:layout'][5][0].doShow = false
  //   else
  //     uiSchema.driver['ui:layout'][5][0].doShow = true
  // }

  onDeliveringAsChange(_props) {
    let {formData,uiSchema} = this.state
    if (_props.state.formData.delivering.delivering_name_as==='driver') {
      formData.delivering.delivering_name = formData.driver.name
      uiSchema.delivering.delivering_name['ui:readonly'] = true
    } else {
      formData.delivering.delivering_name = ''
      uiSchema.delivering.delivering_name['ui:readonly'] = false
    }  
  }

  onTabSelect(e) {
    this.setState({activeKey:e})
  }

  renderFormData(){
    const {formData} = this.state
    const {editMode} = this.props
    if(editMode){
      return (
        <div>
          <div>Vehicle : <br/>
            {JSON.stringify(formData.vehicle)}
          </div>
          <div>Insurer : <br/>
            {JSON.stringify(formData.insurer)}
          </div>
          <div>Driver : <br/>
            {JSON.stringify(formData.driver)}
          </div>
          <div>receiving : <br/>
            {JSON.stringify(formData.receiving)}
          </div>
          <div>Delivery : <br/>
            {JSON.stringify(formData.delivering)}
          </div>
        </div>
      )
    }
  }

  render() {
    let {messages,action} = this.props
    let {activeKey} = this.state
    let titleTab0 = (<div><FontAwsome name="car" />&nbsp;{messages['Car Information']}</div>)
    let titleTab1 = (<div><FontAwsome name="user" />&nbsp;{messages['Customer Information']}</div>)
    let titleTab2 = (<div><FontAwsome name="check-square-o" />&nbsp;{messages['Get Car To Repair']}</div>)
    let titleTab3 = (<div><FontAwsome name="smile-o" />&nbsp;{messages['Delivery Car']}</div>)
    let titleTab4 = (<div><FontAwsome name="university" />&nbsp;{messages['Insurer']}</div>)
    return(
      <div>
        <Tabs activeKey={activeKey} id="uncontrolled-tab-example" onSelect={this.onTabSelect.bind(this)}>
          <Tab eventKey={0} title={titleTab0}>{this.renderTab0()}</Tab>
          <Tab eventKey={4} title={titleTab4}>{this.renderTab4()}</Tab>
          <Tab eventKey={1} title={titleTab1}>{this.renderTab1()}</Tab>
          <Tab eventKey={2} title={titleTab2}>{this.renderTab2()}</Tab>
          {action==='edit'?<Tab eventKey={3} title={titleTab3}>{this.renderTab3()}</Tab>:''}
        </Tabs>
        <div>
            {this.renderFormData()}
        </div>
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  }

  renderTab0() {
    let {messages} = this.props
    let {uiSchema,schema,formData,formContext,fields,widgets,status} = this.state
    return(
        <Provider store={store}>
          <div>
            <div style={{display:(this.props.editMode?'':'none')}}>
              <Checkbox
                checked={this.state.formContext.editMode}
                onChange={() => this.setState(
                  {
                    formContext: {
                      ...this.state.formContext,
                      editMode: !this.state.formContext.editMode,
                    },
                  })
                }
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label=" Edit Mode"
              >
              </Checkbox>
            </div>  
            <Box loading={false}>
              <Box.Header border={true}>
                <Box.Title border={true}>
                  <FontAwsome className="text-blue" name="car" /> {messages['Car Details']}
                </Box.Title>  
              </Box.Header>
              <Box.Body>
                <Row>
                  <Col md={12}>
                    <FormJsonSchema 
                      id={'vehicle-form'}
                      schema={schema.vehicle}
                      uiSchema={uiSchema.vehicle}         
                      fields={fields}
                      widgets={widgets}
                      formData={formData.vehicle}
                      formContext={formContext}
                      FieldTemplate={CustomFieldTemplate}
                      onChange={this.onFormChange.bind(this,'vehicle')}
                    >
                      <div></div>
                    </FormJsonSchema>                
                  </Col>
                </Row>
                <div className="pull-right">
                  {status==='3'?'':<Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;{messages['Save']}</Button>}
                  &nbsp;
                  <Button className="btn btn-default" onClick={this.props.onClose}><FontAwsome name='close' />&nbsp;{messages['Close']}</Button>
                </div>
              </Box.Body>
            </Box>
            <EditInputTypePopup
                input={this.state.editInput}
                show={this.state.inputTypePopup}
                onSave={this.handleEditSchema}
                onHide={() => {
                  this.setState({inputTypePopup: false});
                }}
            />
          </div>  
        </Provider>  
    )
  }

  renderTab1() {
    let {messages} = this.props
    let {uiSchema,schema,formData,formContext,fields,widgets,status} = this.state
    return(
        <Provider store={store}>
          <div>
            <Box loading={false}>
              <Box.Header border={true}>
                <Box.Title border={true}>
                  <FontAwsome className="text-blue" name="user" /> รายละเอียดคนขับ
                </Box.Title>  
              </Box.Header>
              <Box.Body>
                <Row>
                  <Col md={12}>
                    <FormJsonSchema 
                      id={'driver-form'}
                      schema={schema.driver}
                      uiSchema={uiSchema.driver}         
                      fields={fields}
                      widgets={widgets}
                      formData={formData.driver}
                      formContext={formContext}
                      FieldTemplate={CustomFieldTemplate}
                      onChange={this.onFormChange.bind(this,'driver')}
                      // onCustomerTypeChange={this.onCustomerTypeChange(this)}
                      // onCustomerPaymentMethodChange={this.onCustomerPaymentMethodChange(this)}
                      // onCustomerInstallationChange={this.onCustomerInstallationChange(this)}
                    >
                      <div></div>
                    </FormJsonSchema>                
                  </Col>
                </Row>
                <div className="pull-right">
                  {status==='3'?'':<Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;{messages['Save']}</Button>}
                  &nbsp;
                  <Button className="btn btn-default" onClick={this.props.onClose}><FontAwsome name='close' />&nbsp;{messages['Close']}</Button>
                </div>
              </Box.Body>
            </Box>
            {/* <Box loading={false}>
              <Box.Header border={true}>
                <Box.Title border={true}>
                  <FontAwsome className="text-blue" name="user" /> {messages['Contact Details']}
                </Box.Title>  
              </Box.Header>
              <Box.Body>
                <Row>
                  <Col md={12}>
                    <FormJsonSchema 
                      id={'contact-form'}
                      schema={schema.contact}
                      uiSchema={uiSchema.contact}         
                      fields={fields}
                      widgets={widgets}
                      formData={formData.contact}
                      formContext={formContext}
                      FieldTemplate={CustomFieldTemplate}
                      onChange={this.onFormChange.bind(this,'contact')}
                    >
                      <div></div>
                    </FormJsonSchema>                
                  </Col>
                </Row>
                <div className="pull-right">
                  <Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;{messages['Save']}</Button>
                  &nbsp;
                  <Button className="btn btn-default" onClick={this.props.onClose}><FontAwsome name='close' />&nbsp;{messages['Close']}</Button>
                </div>
              </Box.Body>
            </Box> */}
          </div>  
        </Provider>  
    )
  }

  renderTab2() {
    let {messages} = this.props
    let {uiSchema,schema,formData,formContext,fields,widgets,status} = this.state
    return(
        <Provider store={store}>
          <Box loading={false}>
            <Box.Header>
              <Box.Title border={true}>
                <FontAwsome className="text-blue" name="check-square-o" /> {messages['Get Car To Repair']}
              </Box.Title>  
            </Box.Header>
            <Box.Body>
              <Row>
                <Col md={12}>
                  <FormJsonSchema 
                      id={'receiving-form'}
                      schema={schema.receiving}
                      uiSchema={uiSchema.receiving}         
                      fields={fields}
                      widgets={widgets}
                      formData={formData.receiving}
                      formContext={formContext}
                      FieldTemplate={CustomFieldTemplate}
                      onChange={this.onFormChange.bind(this,'receiving')}
                    >
                      <div></div>
                  </FormJsonSchema>                  
                </Col>
              </Row>
              <div className="pull-right">
                {status==='3'?'':<Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;{messages['Save']}</Button>}
                &nbsp;
                <Button className="btn btn-default" onClick={this.props.onClose}><FontAwsome name='close' />&nbsp;{messages['Close']}</Button>
              </div>
            </Box.Body>
          </Box>
        </Provider>
    )
  }

  renderTab3() {
    let {messages} = this.props
    let {uiSchema,schema,formData,formContext,fields,widgets,status} = this.state
    return(
        <Provider store={store}>
          <Box loading={false}>
            <Box.Header>
              <Box.Title border={true}>
                <FontAwsome className="text-blue" name="smile-o" /> {messages['Delivery Car Details']}
              </Box.Title>  
            </Box.Header>
            <Box.Body>
              <Row>
                <Col md={12}>
                  <FormJsonSchema 
                      id={'delivering-form'}
                      schema={schema.delivering}
                      uiSchema={uiSchema.delivering}         
                      fields={fields}
                      widgets={widgets}
                      formData={formData.delivering}
                      formContext={formContext}
                      FieldTemplate={CustomFieldTemplate}
                      onChange={this.onFormChange.bind(this,'delivering')}
                      onDeliveringAsChange={this.onDeliveringAsChange(this)}
                    >
                      <div></div>
                  </FormJsonSchema>                  
                </Col>
              </Row>
              <div className="pull-right">
                {status==='3'?'':<Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;{messages['Save']}</Button>}
                &nbsp;
                <Button className="btn btn-default" onClick={this.props.onClose}><FontAwsome name='close' />&nbsp;{messages['Close']}</Button>
              </div>              
            </Box.Body>            
          </Box>
        </Provider>
    )
  }

  renderTab4() {
    let {messages} = this.props
    let {uiSchema,schema,formData,formContext,fields,widgets,status} = this.state
    return(
        <Provider store={store}>
          <div>
            <Box loading={false}>
              <Box.Header border={true}>
                <Box.Title border={true}>
                  <FontAwsome className="text-blue" name="university" /> {messages['Insurer Details']}
                </Box.Title>  
              </Box.Header>
              <Box.Body>
                <Row>
                  <Col md={12}>
                    <FormJsonSchema 
                      id={'insurer-form'}
                      schema={schema.insurer}
                      uiSchema={uiSchema.insurer}         
                      fields={fields}
                      widgets={widgets}
                      formData={formData.insurer}
                      formContext={formContext}
                      FieldTemplate={CustomFieldTemplate}
                      onChange={this.onFormChange.bind(this,'insurer')}
                    >
                      <div></div>
                    </FormJsonSchema>                
                  </Col>
                </Row>
                <div className="pull-right">
                  {status==='3'?'':<Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;{messages['Save']}</Button>}
                  &nbsp;
                  <Button className="btn btn-default" onClick={this.props.onClose}><FontAwsome name='close' />&nbsp;{messages['Close']}</Button>
                </div>
              </Box.Body>
            </Box>
          </div> 
        </Provider>   
    )
  }
}  

AssetWorkDocGenForm.defaultProps = {
  editMode: true,
  formData: false,
  workNo: ''
}

export default AssetWorkDocGenForm = connect(
  (state) => ({messages: state.message.view.tyre.workdoc.AssetWorkDocGenForm}),null,null,{withRef:true}
)(AssetWorkDocGenForm);



// WEBPACK FOOTER //
// ./src/view/tyre/workdoc/AssetWorkDocGenForm.js